import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VChart from 'vue-echarts'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/utils/echarts'
import '@/styles/index.scss'
import App from './App.vue'
import router from './router'
import { setupRouterGuard } from './router/guard'
import { setupDirectives } from './directives'
import i18n from './locales'
import { setUnauthorizedHandler } from './api/request'
import { useAppStore } from './stores/app'
import { useUserStore } from './stores/user'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(i18n)
app.component('VChart', VChart)
setupDirectives(app)

// 401 统一处理：清理状态并跳登录
setUnauthorizedHandler(() => {
  const userStore = useUserStore()
  userStore.reset()
  const redirect = router.currentRoute.value.fullPath
  void router.replace({ path: '/login', query: redirect !== '/' ? { redirect } : undefined })
})

setupRouterGuard(router)

// 响应式：小屏侧边栏收起
const appStore = useAppStore()
appStore.setDevice(window.innerWidth)
window.addEventListener('resize', () => appStore.setDevice(window.innerWidth))

app.mount('#app')
